import {Download01Icon, File02Icon} from '@/components/ui/icon/Icon'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {UploadedDocument} from '@/types'
import {useGetAttachmentSignedUrl} from '@/services/useGetAttachmentSignedUrl'

/**
 * Attachment uploaded on a single note report (types of the "evaluations" group): shown below the
 * report preview, downloadable through a freshly signed url.
 */
export const MedicalReportDetailsAttachment = ({attachment}: {attachment: UploadedDocument}) => {
    const {t} = useTranslation()

    const signedUrlQuery = useGetAttachmentSignedUrl({
        urlParams: {attachmentId: attachment.id},
        options: {enabled: !!attachment.id}
    })

    return (
        <Flexbox direction="column" gap={2} fullWidth>
            <Text size="textSm" weight="500" palette="neutral" shade="950">
                {t('commons:attachment')}
            </Text>
            <Flexbox align="center" justify="space-between" gap={4} fullWidth>
                <Flexbox align="center" gap={1}>
                    <File02Icon size={18} />
                    <Text size="textSm">{attachment.name || t('commons:document')}</Text>
                </Flexbox>
                {signedUrlQuery.isError ? (
                    <Text size="textSm" palette="danger" shade="500">
                        {t('errors:default')}
                    </Text>
                ) : signedUrlQuery.data?.url ? (
                    <ButtonLink variant="secondary" size="sm" to={signedUrlQuery.data.url} target="_blank">
                        <Download01Icon size={16} />
                        {t('commons:download')}
                    </ButtonLink>
                ) : (
                    <Spinner size={18} />
                )}
            </Flexbox>
        </Flexbox>
    )
}
